module.exports = __webpack_public_path__ + "static/media/7isat.06b533bb.png";